import App from "app/App";
import { PublicClientApplication } from "@azure/msal-browser";
import React from "react";
import ReactDOM from "react-dom";
import { msalConfig } from "app/auth/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <App pca={msalInstance} />
    </React.StrictMode>,
    document.getElementById("root")
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
    globalThis.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('/service-worker.js');
            console.log('SW registered: ', registration);

            // Check for updates periodically
            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                console.log('New service worker found, installing...');

                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        // New service worker available, refresh to update
                        console.log('New service worker available, please refresh');
                    }
                });
            });
        } catch (registrationError) {
            console.log('SW registration failed: ', registrationError);
        }
    });
} 
